import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from 'redux'
import { AppReducer } from "../Components/App/Reducer/AppReducer";


const reducer = combineReducers({
  Apps: AppReducer,
});

const store = configureStore({
  reducer,
})

export default store;